import { inject, injectable } from "inversify";
import { action, makeObservable } from "mobx";
import CompositeDataService from "@/src/application/services/composite-data-service";
import { CompositeDataApi } from "@generated/n3-backend-api";

@injectable()
export default class CompositeDataServiceImpl extends CompositeDataService {
  constructor(@inject(CompositeDataApi) private readonly compositeDataApi: CompositeDataApi) {
    super();
    makeObservable(this, {
      fetchDeviceWithMeasurements: action.bound,
    });
  }

  public async fetchDeviceWithMeasurements(deviceId: number) {
    const response = await this.compositeDataApi.getDeviceWithMeasurements(deviceId);
    return response.data;
  }
}
